// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg {
  background-image: url('freefuse-landing-new-concept-v5.png');
  background-size: cover;
}

.intro-section {
  padding-top: 10px;
  padding-left: 52px;
}

.dashboard-view-section {
  margin-top: 62px;
  padding-left: 52px;
  background-color: #4d0078;
  border-top: 3px solid #da6c31;
}

.review-view {
  color: white;
  margin-top: 10px;
  padding-left: 52px;
  border-top: 3px solid #da6c31;
  background-color: #4d0078;
}

.showcase {
  margin-top: 10px;
  padding-left: 52px;
}

.second-bar {
  border-top: 3px solid #da6c31;
  background-color: #4d0078;
}

.third-bar {
  border-top: 3px solid #da6c31;
  background-color: #4d0078;
  min-height: 285px;
}

.discussion-board {
  color: white;
}

.icon-view {
  display: flex;
  font-size: 12px;
}

.top-action-view {
  display: flex;
  justify-content: space-between;
}

.second-bar h2 {
  color: white;
  font-size: 19px;
}

.main-name {
  font-size: 15px;
}

.reply-input {
  color: white;
  border-top: 0;
  background: no-repeat;
  border-left: 0;
  border-right: 0;
  border-bottom: 1px solid white;
  margin-bottom: 12px;
}

.reply-btn {
  border: none;
  background: #007bff;
  color: white;
  border-radius: 5px;
  font-size: 12px;
  padding: 4px 14px;
  margin-left: 8px;
}

.viewAll {
  color: white;
  font-size: 13px;
}

.viewAll:hover {
  text-decoration: underline;
  cursor: pointer;
}

.comments {
  font-size: 12px;
}

.lab-lecture {
  font-size: 14px;
}

.border-set {
  border-top: 3px solid #da6c31;
}

.arrow-style {
  color: #000000 !important;
  padding: 2px 7px;
  font-size: 21px;
  border-radius: 50% !important;
}

.first-bar {
  background-color: none !important;
}

.internal-view {
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 3px solid #da6c31;
  background-color: #4d0078;
  color: white;
}

h1 {
  color: #ffffff;
  text-align: center;
}

h1.section-heading {
  margin-bottom: 25px;

  /*WC 04062022 */
  /*margin-top: 50px;*/
  /* WC 04062022 */
  margin-top: 75px;
  color:#ffffff;
}

.intro {
  background-color: #522195;
  color: #ffffff;
  border-radius: 12px;
  padding: 15px;
  height: 131px;
  box-shadow: 2px 2px 3px 0px rgba(0, 0, 0, 0.4);
  overflow: hidden;
}

.intro img {
  width: 15%;
}

.intro div.d-table {
  width: 85%;
  float: right;
  padding-left: 15%;
}

.video-bg {
  background-image: url('feature-video.png');
  background-repeat: no-repeat;
  background-size: cover;
  height: auto;
}

.feature-video-section {
  margin-top: 50px;
  margin-bottom: 50px;
  padding-left: 52px;
}

.feature-video img.poster {
  width: 100%;
  height: 400px;
  object-fit: fill;
}

.feature-video .feature-info {
  position: absolute;
  z-index: 9;
  padding: 15px;
  color: #ffffff;
  bottom: 40px;
}

.feature-video .feature-info h2 {
  margin-bottom: 25px;
  cursor: pointer;
}

.feature-video .feature-info .categories {
  padding: 10px 0px;
  height: auto;
}

.feature-video .feature-info .categories span.category {
  text-transform: uppercase;
  border: 1px solid #ffffff;
  padding: 3px 10px;
  margin-right: 10px;
  border-radius: 16px;
  display: inline-block;
  font-size: 14px;
}

.feature-video .feature-info .decision-info img {
  width: 30px;
  height: 30px;
  margin-right: 15px;
}

.feature-video .feature-info .btn-interact {
  background-color: #ffffff;
  color: #522195;
  margin-right: 15px;
  padding: 6px 15px;
}

.feature-video .feature-info .btn-outcomes {
  background-color: transparent;
  color: #ffffff;
  border: 1px solid #ffffff;
  padding: 6px 15px;
}

.trending-section {
  margin-top: 50px;
  margin-bottom: 50px;
  padding-left: 52px;
}

.trending-section h4.section-heading {
  color: #ffffff;
  margin-bottom: 20px;
  font-size: 1.5rem;
}

.trending-video img.poster {
  width: 100%;
  height: 35vh !important;
  object-fit: cover;
}

.trending-video {
  position: relative;
}

.group-text-view-para-1 {
  font-size: 15px;
  cursor: pointer;
  font-weight: 600;
}

.group-text-view-para-2 {
  font-size: 12px;
  cursor: pointer;
}

.group-text-view {
  position: absolute;
  background: #0000007d;
  color: white;
  padding: 4px 13px 3px 18px;
  top: 3px;
}

.trending-video:hover .video-info {
  top: 0;
}

.trending-video:hover .top-choices {
  opacity: 1;
  z-index: 9;
  width: 100% !important;
}

.interact-cardimg-iconstext {
  width: 120px;
  border-radius: 2px;
  padding: 10px 10px;
  position: absolute;
  top: 0px;
  right: 15px;
}

.interact-cardimg-iconstext > span {
  background-color: #ffffff;
  border-radius: 5px;
  padding: 3px;
}

.interact-cardimg-iconstext > span img {
  width: 20px !important;
  height: 20px;
  margin-right: 5px;
}

.interact-cardimg-iconstext > span b {
  font-size: 12px;
}

.trending-video .video-info {
  position: absolute;
  bottom: 0px;
  color: #ffffff;
  padding: 10px;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
}

.trending-video .video-info p {
  display: inline;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

.feature-video {
  position: relative;
}

.feature-video::before {
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
  background-color: rgba(0, 0, 0, 0.2);
}

.trending-video .video-info h6 {
  margin-top: 10px;
  margin-bottom: 0px;
  font-size: 1rem;
}

.trending-video .top-choices {
  position: absolute;
  color: #ffffff;
  padding: 10px;
  background: rgba(0, 0, 0, 0.5);
  width: calc(100% - 30px);
  bottom: 0px;
  opacity: 0;
}

.trending-video .top-choices .pro-group {
  margin-bottom: 10px;
}

.trending-video .top-choices .pro-group h6 {
  font-weight: normal;
  font-size: 12px;
}

.trending-video .top-choices .pro-group .progress {
  height: 6px;
}

.trending-video .top-choices .pro-group .progress .progress-bar {
  background-color: #522195;
}

.profile-25 {
  width: 40px !important;
  height: 40px !important;
  margin-right: 5px !important;
  object-fit: cover;
  cursor: pointer;
  border: 2px solid #ffffff;
  border-radius: 50%;
}


.highly-interactive-section {
  margin-top: 50px;
  margin-bottom: 50px;
  padding-left: 52px;
}

.highly-interactive-section h4.section-heading {
  color: #ffffff;
  margin-bottom: 20px;
  font-size: 1.5rem;
}

.interactive-video img.poster {
  width: 100%;
  height: 35vh !important;
  position: relative;
  object-fit: cover;
}

.interactive-video .decisions {
  position: absolute;
  top: 0px;
  padding: 10px;
  color: #ffffff;
  background: rgba(0, 0, 0, 0.5);
  width: calc(100% - 30px);
}

.interactive-video .decisions p {
  margin-bottom: 0px;
}

.interactive-video .decisions .touch-icon {
  float: left;
  width: 40px;
  margin-right: 5px;
}

.interactive-video .decisions .touch-icon img {
  width: 40px;
  height: 40px;
}

.interactive-video .video-info {
  position: absolute;
  bottom: 0px;
  color: #ffffff;
  padding: 10px;
  background: rgba(0, 0, 0, 0.5);
  width: calc(100% - 30px);
}

.interactive-video .video-info p {
  display: inline;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

.interactive-video .video-info h6 {
  margin-top: 10px;
  margin-bottom: 0px;
  font-size: 1rem;
}

.owl-nav {
  opacity: 0 !important;
}

.container-fluid .owl-nav {
  opacity: 1 !important;
}


.latest-section {
  margin-top: 50px;
  margin-bottom: 50px;
  padding-left: 52px;
}

.latest-section h4.section-heading {
  color: #ffffff;
  margin-bottom: 20px;
  font-size: 1.5rem;
}

.latest-video img.poster {
  width: 100%;
  height: 300px !important;
  object-fit: cover;
}

.latest-video .video-info {
  position: absolute;
  bottom: 0px;
  color: #ffffff;
  padding: 10px;
  background: rgba(0, 0, 0, 0.5);
  width: calc(100% - 30px);
}

.latest-video .video-info p {
  display: inline;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

.latest-video .video-info h6 {
  margin-top: 10px;
  margin-bottom: 0px;
  font-size: 1rem;
}

.pop-categories-section {
  margin-top: 50px;
  margin-bottom: 50px;
  padding-left: 52px;
}

.pop-categories-section .section-heading {
  color: #ffffff;
  margin-bottom: 20px;
  font-size: 1.5rem;
}

.pop-categories-section .pop-categories .card {
  height: 230px;
  margin-bottom: 20px;
  border: none;
  background: none;
  transition: all 0.2s linear;
  cursor: pointer;
}

.pop-categories-section .pop-categories .card:hover {
  transform: scale(1.1);
  box-shadow: 1px 1px 10px 2px black;
  z-index: 1;
}

.pop-categories .card .card-img-overlay {
  color: #ffffff;
  top: unset;
  bottom: 0px;
  padding: 12px;
}

.pop-categories .card .card-img-overlay h6,
.pop-categories .card .card-img-overlay span {
  margin-bottom: 0px;
  font-size: 14px;
}

.pop-categories .card .card-img-overlay h3 {
  font-size: 24px;
}

.pop-categories-section .pop-categories .card > img {
  width: 100%;
  height: 100%;
}

.pop-categories-section .pop-categories {
  margin-bottom: 50px;
}

.btns {
  display: flex;
  margin: 4px;
  justify-content: flex-end;
}

.owl-theme .owl-nav.disabled + .owl-dots {
  margin-top: 10px;
  position: absolute !important;
  bottom: 34px;
  left: 134px;
}

.fa-angle-right {
  color: white;
  padding: 2px 7px;
  font-size: 21px;
  border-radius: 4px;
  background-color: white;
}

.fa-angle-left {
  color: white;
  padding: 2px 7px;
  font-size: 21px;
  border-radius: 4px;
  background-color: white;
}

.testTrending img.poster {
  width: 100%;
  height: 48vh !important;
  object-fit: cover;
}


@media (max-width: 700px) {
  .feature-video-section {
    margin-bottom: 50px;
    z-index: 0;
  }
  .dashboard-view-section {
    padding-left: 0px;
  }
  .showcase {
    margin-top: 10px;
    padding-left: 0px;
  }
  .review-view {
    margin-top: 10px;
    padding-left: 0px;
  }
}

@media (max-width: 991px) {
  .trending-video img.poster {
    height: 300px !important;
  }
  .feature-video-section {
    margin-bottom: 50px;
    z-index: 0;
  }
  .poster {
    width: 100% !important;
    height: 183px !important;
    object-fit: fill;
  }
  .interact-vid-sec {
    padding: 30px 30px 0px !important;
  }
  .custom-height,
  .position-relative.pop5 {
    height: auto !important;
    margin-bottom: 30px;
  }
  .card-body {
    padding-bottom: 20px !important;
  }
  .margin-right-0-mobile {
    margin-right: 0px !important;
  }
  .intro-section,
  .feature-video-section,
  .highly-interactive-section,
  .trending-section,
  .latest-section,
  .pop-categories-section {
    padding-left: 0;
  }
  .intro-section {
    padding-top: 51px;
  }
  .intro {
    margin-bottom: 20px;
  }
  .feature-video .feature-info {
    bottom: 0;
  }
  .feature-video .feature-info {
    position: static !important;
    z-index: 9;
    padding: 15px;
    color: #ffffff;
  }
  .feature-video-section {
    margin-top: 0 !important;
  }
}

.posterImg {
  padding: 5px;
  width: 100%;
  height: 195px;
  object-fit: contain;
}


.hb-film-sec-1 .hb-logo-content {
  display: flex;
}

.hb-film-sec-1 .hb-logo-content > .logo {
  border-radius: 50%;
  margin-right: 30px;
}

.hb-film-sec-1 .hb-logo-content > .logo img {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  object-fit: cover;
}

.hb-logo-content .logo-txt > h3 {
  font-size: 22px;
  display: block;
  word-break: break-all;
}

.hb-logo-content .logo-txt > p {
  font-size: 14px;
}

.hb-logo-content .logo-txt > button {
  background-color: #6e5eff;
  padding: 4px 34px;
  font-size: 12px;
  border-radius: 5px;
  outline: none;
  border: none;
  color: white;
  margin-bottom: 10px;
}

.hb-logo-content .logo-txt > h6,
.hb-film-sec-1 .hb-follower-content > h6 {
  font-weight: bold;
  font-size: 15px;
}

.hb-film-sec-1 .hb-follower-content > p span {
  margin-right: 20px;
  font-size: 15px;
  color: #6e5eff;
}

.hb-film-sec-1 .hb-follower-content > a {
  border: 1px solid black;
  padding: 4px 12px;
  border-radius: 4px;
  color: black;
  font-size: 12px;
  margin-bottom: 10px;
  display: inline-block !important;
  text-decoration: none;
}

.slises {
  margin-top: 10px;
  font-size: 14px;
  color: #ffffff;
}

.test.owl-carousel .owl-nav button.owl-next span {
  color: #fdfdfd !important;
}

.test.owl-carousel .owl-nav button.owl-prev span {
  color: #ffffff;
}

.hb-film-sec-1 .hb-follower-content > a {
  margin-right: 10px;
}

.big-video-card .card-title {
  margin-bottom: 0px;
  font-size: 18px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100;
}

.big-video-card .card-body {
  padding: 12px 16px;
  background: white;
}

.big-video-card .card img {
  height: 360px;
  object-fit: cover;
}

.big-video-card .card-text > span:first-child {
  margin-right: 10px;
}

.big-video-card .card-text > span:last-child {
  color: #a5a2a2;
  display: block;
  margin-top: 8px;
}

.big-video-card .card-text > span {
  font-size: 13px;
}

.history-video-card .hv-card img {
  width: 100%;
  height: 102px;
  object-fit: cover;
}

.history-video-card > a {
  margin-bottom: 10px;
  text-decoration: none;
  display: block;
  font-size: 14px;
  color: #6e5eff;
}

.view-all {
  margin-bottom: 10px;
  text-decoration: none;
  display: block;
  font-size: 14px;
  color: #6e5eff;
  position: absolute;
  right: 20px;
  top: -40px;
}

.big-video-card .over {
  right: 0;
}

.big-video-card {
  cursor: pointer;
}

.history-video-card > a:hover .hv-card-text > h5 {
  color: #6e5eff;
}

.history-video-card > a .row .pl {
  padding-left: 6px;
}

.history-video-card > h4 {
  font-size: 17px;
  margin-bottom: 15px;
}

.history-video-card .hv-card-text > h5 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 0px;
  color: black;
  transition: all 0.2s linear;
}

.history-video-card .hv-card-text > span {
  font-size: 13px;
  color: black;
  margin-right: 6px;
  margin-bottom: 8px;
  display: inline-block;
}

.history-video-card .hv-card-text > p {
  font-size: 12px;
  color: #929090;
}

.hb-film-sec-2 {
  margin-top: 25px;
}

.hb-film-sec-3 {
  margin-top: 30px;
}

.hb-film-sec-3 .recent-con .media-body > h5 {
  font-size: 15px;
  color: #6e5eff;
  margin-bottom: 4px;
}

.hb-film-sec-3 .recent-con .media-body > span {
  display: block;
  font-size: 12px;
}

.hb-film-sec-3 .rfTab .nav-link.active {
  background-color: unset;
  color: black;
  border-top: 2px solid black;
}

.hb-film-sec-3 .rfTab .nav-link {
  color: #929090;
  border-radius: unset;
  padding: 6px 0px;
  border-top: 2px solid transparent;
}

.hb-film-sec-3 ul.rfTab {
  margin-bottom: 10px;
}

.hb-film-sec-4 {
  margin-top: 2px;
  padding-bottom: 20px;
}

.profile-view {
  margin-top: 29px;
  color: white;
}

.name1 {
  margin-bottom: 0;
  font-size: 20px;
}

.major {
  margin-top: 12px;
  margin-bottom: 6px;
  font-weight: 600;
  font-size: 14px;
}

.type-view {
  border: 1px solid;
  border-radius: 3px;
  font-size: 12px;
  padding: 2px 3px;
  text-align: center;
}

.followers-view {
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  font-size: 13px;
}

.profile-img {
  margin-bottom: 6px;
}

.profile-img img {
  width: 44px;
  height: 44px;
  border: 2px solid white;
  border-radius: 50%;
  object-fit: cover;
}

.profile-img-reply img {
  width: 35px;
  height: 35px;
  border: 2px solid white;
  border-radius: 50%;
}

.type-view p {
  margin-bottom: 0;
}

.since {
  margin-bottom: 0;
  font-size: 12px;
  opacity: 0.7;
}

.hb-film-sec-4 > div h4 {
  font-size: 17px;
  color: black;
  margin-bottom: 5px;
}

.v-choice-carousel img {
  height: 200px;
}

.v-choice-carousel {
  position: relative;
}

.v-choice-carousel > .owl-nav {
  width: 100%;
}

.v-choice-carousel > .owl-nav > button {
  position: absolute;
  top: 50%;
  transform: translateY(-325%);
  font-size: 25px !important;
  background-color: white !important;
  border-radius: 50%;
  outline: none;
}

.dottype {
  display: inline-block;
  left: 0;
  top: 5px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  margin-right: 0;
  background: #000;
  vertical-align: middle;
  margin-right: 5px;
  font-weight: 600;
}

.hv-card-text .recent-cat.cateogyclass {
  display: none !important;
}

.hv-card-text .recent-cat.cateogyclass.class0 {
  display: inline-block !important;
}

.upli {
  padding-right: 10px;
  font-size: 12px;
  padding-left: 10px;
  word-break: break-all;
  position: relative;
  display: block;
  margin-bottom: 10px;
}

.upli.upli0 {
  font-weight: bold;
}

.dottype.dottype0 {
  background: #a649c7;
}

.dottype.dottype1 {
  background: #efb43a;
}

.dottype.dottype2 {
  background: #3dc99c;
}

.dottype.dottype3 {
  background: #db6a8e;
}

.tbalesa {
  width: 100%;
  display: table;
}

.v-choice-carousel .owl-nav button.owl-next,
.v-choice-carousel .owl-nav button.owl-prev {
  padding: 0px 8px !important;
  border: 2px solid #ffffff;
  color: white;
}

.v-choice-carousel > .owl-nav button:first-child {
  left: -15px;
}

.v-choice-carousel > .owl-nav button:last-child {
  right: -15px;
}

.v-choice-info {
  padding-top: 12px;
}

.v-choice-carousel .v-choice-info .lr-arrow a {
  position: unset;
  opacity: 1;
  border: 2px solid #727272;
  width: 20px;
  height: 20px;
  border-radius: 2px;
}

.v-choice-carousel .v-choice-info .lr-arrow {
  float: right;
  display: flex;
  justify-content: space-between;
  width: 45px;
}

.v-choice-info .carousel-control-prev-icon {
  background-image: url('left-arrow.svg');
  width: 12px;
  height: 12px;
}

.v-choice-info .carousel-control-next-icon {
  background-image: url('right-arrow.svg');
  width: 12px;
  height: 12px;
}

.v-choice-info .media img {
  width: 40px;
  height: 40px;
}

.hb-film-sec-4 .v-choice-info ul {
  padding-left: 0px;
  margin-bottom: 0;
}

.hb-film-sec-4 .v-choice-info ul li {
  list-style-type: none;
  font-size: 13px;
  color: white;
}

.tbalesa3 {
  padding: 10px !important;
  z-index: 9;
  margin-left: 65px;
}

.v-choice-info > span {
  color: #929090;
  font-size: 14px;
}

.v-choice-info .media .media-body > h6 {
  margin-bottom: 0px;
  font-size: 15px;
}

.v-choice-carousel .carousel-indicators .active {
  background-color: #6e5eff;
}

.v-choice-carousel .carousel-caption {
  text-align: left;
  left: 0px;
  top: 0px;
  padding-top: 10px;
  padding-left: 13px;
  font-size: 14px;
  font-weight: 600;
}

.v-choice-carousel .v-choice-info ul li samp {
  margin-right: 2px;
  margin-left: 3px;
}


.hb-bullet-c1 {
  color: #6e5eff;
}

.hb-bullet-c2 {
  color: #dfbd5b;
}

.hb-bullet-c3 {
  color: #65cf9c;
}

.hb-bullet-c4 {
  color: #d14870;
}


.hb-film-sec-5 .rfTab .nav-link.active {
  background-color: unset;
  color: #6e5eff;
  border-top: 2px solid #6e5eff;
  font-weight: 600;
}

.hb-film-sec-5 .rfTab .nav-link {
  color: #929090;
  border-radius: unset;
  padding: 6px 20px;
  border-top: 2px solid transparent;
}

.hb-film-sec-5 .rfTab .nav-link.active .like,
.hb-film-sec-5 .rfTab .nav-link.active .share {
  fill: #6e5eff;
}

.card .over {
  right: 0;
}

.like-share-content .card-body > h5 {
  font-size: 16px;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.like-share-content .card-body {
  padding: 12px 10px;
}

.like-share-content .card-body > p {
  font-size: 12px;
}

.like-share-content .card-body > p span:last-child {
  color: #a5a2a2;
  display: block;
}

.like-share-content .card {
  background-color: transparent;
  border: none;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
  margin: 5px;
}

.like-share-content .row > div {
  padding: 0;
  cursor: pointer;
}

#hbAct {
  background: #fff;
  padding: 15px 45px;
}

.activityes img {
  height: 150px;
  object-fit: cover;
}

.poster {
  width: 93%;
}

.my-tags {
  margin-top: 10px;
  display: block;
  color: #a5a2a2 !important;
}

.my-tags span {
  margin-right: 5px;
}

.like-share-content .card:hover {
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.5);
  background: #fff;
}

.afterlogindashboard {
  margin-top: 65px;
  padding-left: 80px;
}

.hb-follower-content a {
  text-decoration: none;
}

.recent-cat {
  color: #a5a2a2;
  display: inline-block !important;
  font-size: 13px;
  margin-right: 10px;
}

.video-container {
  padding-top: 15px;
  padding-bottom: 15px;
  margin-bottom: 15px;
}

.over {
  position: absolute;
  right: 15px;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
}

.over span {
  margin: 5px;
  color: #fff !important;
  font-size: 12px !important;
}

.over span img {
  width: auto !important;
  height: 14px !important;
}

.choice p.main-title {
  color: #fff;
  position: absolute;
  top: 10px;
  left: -1px;
  z-index: 9;
  font-weight: 600;
  font-size: 14px;
  background: #0000007d;
  padding: 3px;
  border-radius: 0px 0px 3px 0px;
}

.choice .cat {
  margin-right: 10px;
  font-size: 14px;
  padding: 4px;
  position: relative;
  padding-left: 10px;
  display: inline-block;
}

.choice .cat::before {
  position: absolute;
  top: 11px;
  left: 0;
  content: "";
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #000;
}

.choice .stats {
  color: #000;
  margin-right: 10px;
  margin-bottom: 5px;
  display: inline-block;
  font-size: 14px;
  margin-top: 10px;
}

.img-poster {
  width: 100%;
  margin-top: 10px;
}

.bullet::before {
  position: absolute;
  top: 11px;
  left: 0;
  content: "";
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #000;
}

.active-since {
  margin-bottom: 10px;
  color: #929090;
  font-size: 14px;
}

@media (max-width: 991px) {
  .afterlogindashboard {
    padding-left: 15px;
  }
  .hb-film-sec-1 .hb-follower-content > a {
    margin-bottom: 10px;
  }
  .history-video-card > a .row .pl {
    padding-left: 15px;
    margin-top: 10px;
    margin-bottom: 30px;
  }
  .activityes img {
    width: 100%;
    height: auto;
    margin-bottom: 10px;
  }
  .history-video-card .hv-card img {
    height: auto;
  }
  .tbalesa3 {
    margin-left: 0;
  }
  .big-video-card .card img {
    height: auto;
  }
}

::ng-deep .carousel-control-next {
  width: 2% !important;
  position: absolute;
  right: 18px;
}

::ng-deep .carousel-indicators {
  display: none;
}

::ng-deep .carousel-control-prev {
  width: 2% !important;
  position: absolute;
  left: 13px;
}

.interests-type ul {
  list-style: none;
  padding-left: 0px;
  position: relative;
  right: 3px;
}

.interests-type ul li {
  margin: 0px 4px;
  font-size: 11px;
  border: 1px solid white;
  border-radius: 2px;
  padding: 1px 6px;
  display: inline-block;
  margin-bottom: 10px;
}

@media only screen and (max-width: 991px) {
  .dashboard-view-section {
    margin-top: 92px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/beforeLogin/new-landing-page/new-landing-page.component.css"],"names":[],"mappings":"AAAA;EACE,4DAAmF;EACnF,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;;EAEnB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,0CAAiE;EACjE,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,0BAA0B;EAC1B,QAAQ;AACV;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,UAAU;EACV,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,wBAAwB;EACxB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;;AAGA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,uBAAuB;EAEvB,iBAAiB;AACnB;;;AAGA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,wBAAwB;IACxB,gBAAgB;EAClB;EACA;IACE,iCAAiC;EACnC;EACA;;IAEE,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,+BAA+B;EACjC;EACA;IACE,4BAA4B;EAC9B;EACA;;;;;;IAME,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,SAAS;EACX;EACA;IACE,2BAA2B;IAC3B,UAAU;IACV,aAAa;IACb,cAAc;EAChB;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,4BAA4B;EAC5B,0BAA0B;EAC1B,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;;EAEE,2BAA2B;EAC3B,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,uCAAgE;EAChE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wCAAiE;EACjE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,uBAAuB;EACvB,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,8CAA8C;EAC9C,WAAW;AACb;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".bg {\r\n  background-image: url(\"../../../assets/images/freefuse-landing-new-concept-v5.png\");\r\n  background-size: cover;\r\n}\r\n\r\n.intro-section {\r\n  padding-top: 10px;\r\n  padding-left: 52px;\r\n}\r\n\r\n.dashboard-view-section {\r\n  margin-top: 62px;\r\n  padding-left: 52px;\r\n  background-color: #4d0078;\r\n  border-top: 3px solid #da6c31;\r\n}\r\n\r\n.review-view {\r\n  color: white;\r\n  margin-top: 10px;\r\n  padding-left: 52px;\r\n  border-top: 3px solid #da6c31;\r\n  background-color: #4d0078;\r\n}\r\n\r\n.showcase {\r\n  margin-top: 10px;\r\n  padding-left: 52px;\r\n}\r\n\r\n.second-bar {\r\n  border-top: 3px solid #da6c31;\r\n  background-color: #4d0078;\r\n}\r\n\r\n.third-bar {\r\n  border-top: 3px solid #da6c31;\r\n  background-color: #4d0078;\r\n  min-height: 285px;\r\n}\r\n\r\n.discussion-board {\r\n  color: white;\r\n}\r\n\r\n.icon-view {\r\n  display: flex;\r\n  font-size: 12px;\r\n}\r\n\r\n.top-action-view {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.second-bar h2 {\r\n  color: white;\r\n  font-size: 19px;\r\n}\r\n\r\n.main-name {\r\n  font-size: 15px;\r\n}\r\n\r\n.reply-input {\r\n  color: white;\r\n  border-top: 0;\r\n  background: no-repeat;\r\n  border-left: 0;\r\n  border-right: 0;\r\n  border-bottom: 1px solid white;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.reply-btn {\r\n  border: none;\r\n  background: #007bff;\r\n  color: white;\r\n  border-radius: 5px;\r\n  font-size: 12px;\r\n  padding: 4px 14px;\r\n  margin-left: 8px;\r\n}\r\n\r\n.viewAll {\r\n  color: white;\r\n  font-size: 13px;\r\n}\r\n\r\n.viewAll:hover {\r\n  text-decoration: underline;\r\n  cursor: pointer;\r\n}\r\n\r\n.comments {\r\n  font-size: 12px;\r\n}\r\n\r\n.lab-lecture {\r\n  font-size: 14px;\r\n}\r\n\r\n.border-set {\r\n  border-top: 3px solid #da6c31;\r\n}\r\n\r\n.arrow-style {\r\n  color: #000000 !important;\r\n  padding: 2px 7px;\r\n  font-size: 21px;\r\n  border-radius: 50% !important;\r\n}\r\n\r\n.first-bar {\r\n  background-color: none !important;\r\n}\r\n\r\n.internal-view {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-top: 3px solid #da6c31;\r\n  background-color: #4d0078;\r\n  color: white;\r\n}\r\n\r\nh1 {\r\n  color: #ffffff;\r\n  text-align: center;\r\n}\r\n\r\nh1.section-heading {\r\n  margin-bottom: 25px;\r\n\r\n  /*WC 04062022 */\r\n  /*margin-top: 50px;*/\r\n  /* WC 04062022 */\r\n  margin-top: 75px;\r\n  color:#ffffff;\r\n}\r\n\r\n.intro {\r\n  background-color: #522195;\r\n  color: #ffffff;\r\n  border-radius: 12px;\r\n  padding: 15px;\r\n  height: 131px;\r\n  box-shadow: 2px 2px 3px 0px rgba(0, 0, 0, 0.4);\r\n  overflow: hidden;\r\n}\r\n\r\n.intro img {\r\n  width: 15%;\r\n}\r\n\r\n.intro div.d-table {\r\n  width: 85%;\r\n  float: right;\r\n  padding-left: 15%;\r\n}\r\n\r\n.video-bg {\r\n  background-image: url(\"../../../assets/images/feature-video.png\");\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  height: auto;\r\n}\r\n\r\n.feature-video-section {\r\n  margin-top: 50px;\r\n  margin-bottom: 50px;\r\n  padding-left: 52px;\r\n}\r\n\r\n.feature-video img.poster {\r\n  width: 100%;\r\n  height: 400px;\r\n  object-fit: fill;\r\n}\r\n\r\n.feature-video .feature-info {\r\n  position: absolute;\r\n  z-index: 9;\r\n  padding: 15px;\r\n  color: #ffffff;\r\n  bottom: 40px;\r\n}\r\n\r\n.feature-video .feature-info h2 {\r\n  margin-bottom: 25px;\r\n  cursor: pointer;\r\n}\r\n\r\n.feature-video .feature-info .categories {\r\n  padding: 10px 0px;\r\n  height: auto;\r\n}\r\n\r\n.feature-video .feature-info .categories span.category {\r\n  text-transform: uppercase;\r\n  border: 1px solid #ffffff;\r\n  padding: 3px 10px;\r\n  margin-right: 10px;\r\n  border-radius: 16px;\r\n  display: inline-block;\r\n  font-size: 14px;\r\n}\r\n\r\n.feature-video .feature-info .decision-info img {\r\n  width: 30px;\r\n  height: 30px;\r\n  margin-right: 15px;\r\n}\r\n\r\n.feature-video .feature-info .btn-interact {\r\n  background-color: #ffffff;\r\n  color: #522195;\r\n  margin-right: 15px;\r\n  padding: 6px 15px;\r\n}\r\n\r\n.feature-video .feature-info .btn-outcomes {\r\n  background-color: transparent;\r\n  color: #ffffff;\r\n  border: 1px solid #ffffff;\r\n  padding: 6px 15px;\r\n}\r\n\r\n.trending-section {\r\n  margin-top: 50px;\r\n  margin-bottom: 50px;\r\n  padding-left: 52px;\r\n}\r\n\r\n.trending-section h4.section-heading {\r\n  color: #ffffff;\r\n  margin-bottom: 20px;\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.trending-video img.poster {\r\n  width: 100%;\r\n  height: 35vh !important;\r\n  object-fit: cover;\r\n}\r\n\r\n.trending-video {\r\n  position: relative;\r\n}\r\n\r\n.group-text-view-para-1 {\r\n  font-size: 15px;\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n}\r\n\r\n.group-text-view-para-2 {\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n}\r\n\r\n.group-text-view {\r\n  position: absolute;\r\n  background: #0000007d;\r\n  color: white;\r\n  padding: 4px 13px 3px 18px;\r\n  top: 3px;\r\n}\r\n\r\n.trending-video:hover .video-info {\r\n  top: 0;\r\n}\r\n\r\n.trending-video:hover .top-choices {\r\n  opacity: 1;\r\n  z-index: 9;\r\n  width: 100% !important;\r\n}\r\n\r\n.interact-cardimg-iconstext {\r\n  width: 120px;\r\n  border-radius: 2px;\r\n  padding: 10px 10px;\r\n  position: absolute;\r\n  top: 0px;\r\n  right: 15px;\r\n}\r\n\r\n.interact-cardimg-iconstext > span {\r\n  background-color: #ffffff;\r\n  border-radius: 5px;\r\n  padding: 3px;\r\n}\r\n\r\n.interact-cardimg-iconstext > span img {\r\n  width: 20px !important;\r\n  height: 20px;\r\n  margin-right: 5px;\r\n}\r\n\r\n.interact-cardimg-iconstext > span b {\r\n  font-size: 12px;\r\n}\r\n\r\n.trending-video .video-info {\r\n  position: absolute;\r\n  bottom: 0px;\r\n  color: #ffffff;\r\n  padding: 10px;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  width: 100%;\r\n}\r\n\r\n.trending-video .video-info p {\r\n  display: inline;\r\n  font-size: 1rem;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n}\r\n\r\n.feature-video {\r\n  position: relative;\r\n}\r\n\r\n.feature-video::before {\r\n  position: absolute;\r\n  content: \"\";\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 9;\r\n  background-color: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.trending-video .video-info h6 {\r\n  margin-top: 10px;\r\n  margin-bottom: 0px;\r\n  font-size: 1rem;\r\n}\r\n\r\n.trending-video .top-choices {\r\n  position: absolute;\r\n  color: #ffffff;\r\n  padding: 10px;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  width: calc(100% - 30px);\r\n  bottom: 0px;\r\n  opacity: 0;\r\n}\r\n\r\n.trending-video .top-choices .pro-group {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.trending-video .top-choices .pro-group h6 {\r\n  font-weight: normal;\r\n  font-size: 12px;\r\n}\r\n\r\n.trending-video .top-choices .pro-group .progress {\r\n  height: 6px;\r\n}\r\n\r\n.trending-video .top-choices .pro-group .progress .progress-bar {\r\n  background-color: #522195;\r\n}\r\n\r\n.profile-25 {\r\n  width: 40px !important;\r\n  height: 40px !important;\r\n  margin-right: 5px !important;\r\n  object-fit: cover;\r\n  cursor: pointer;\r\n  border: 2px solid #ffffff;\r\n  border-radius: 50%;\r\n}\r\n\r\n\r\n.highly-interactive-section {\r\n  margin-top: 50px;\r\n  margin-bottom: 50px;\r\n  padding-left: 52px;\r\n}\r\n\r\n.highly-interactive-section h4.section-heading {\r\n  color: #ffffff;\r\n  margin-bottom: 20px;\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.interactive-video img.poster {\r\n  width: 100%;\r\n  height: 35vh !important;\r\n  position: relative;\r\n  object-fit: cover;\r\n}\r\n\r\n.interactive-video .decisions {\r\n  position: absolute;\r\n  top: 0px;\r\n  padding: 10px;\r\n  color: #ffffff;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  width: calc(100% - 30px);\r\n}\r\n\r\n.interactive-video .decisions p {\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.interactive-video .decisions .touch-icon {\r\n  float: left;\r\n  width: 40px;\r\n  margin-right: 5px;\r\n}\r\n\r\n.interactive-video .decisions .touch-icon img {\r\n  width: 40px;\r\n  height: 40px;\r\n}\r\n\r\n.interactive-video .video-info {\r\n  position: absolute;\r\n  bottom: 0px;\r\n  color: #ffffff;\r\n  padding: 10px;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  width: calc(100% - 30px);\r\n}\r\n\r\n.interactive-video .video-info p {\r\n  display: inline;\r\n  font-size: 1rem;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n}\r\n\r\n.interactive-video .video-info h6 {\r\n  margin-top: 10px;\r\n  margin-bottom: 0px;\r\n  font-size: 1rem;\r\n}\r\n\r\n.owl-nav {\r\n  opacity: 0 !important;\r\n}\r\n\r\n.container-fluid .owl-nav {\r\n  opacity: 1 !important;\r\n}\r\n\r\n\r\n.latest-section {\r\n  margin-top: 50px;\r\n  margin-bottom: 50px;\r\n  padding-left: 52px;\r\n}\r\n\r\n.latest-section h4.section-heading {\r\n  color: #ffffff;\r\n  margin-bottom: 20px;\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.latest-video img.poster {\r\n  width: 100%;\r\n  height: 300px !important;\r\n  object-fit: cover;\r\n}\r\n\r\n.latest-video .video-info {\r\n  position: absolute;\r\n  bottom: 0px;\r\n  color: #ffffff;\r\n  padding: 10px;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  width: calc(100% - 30px);\r\n}\r\n\r\n.latest-video .video-info p {\r\n  display: inline;\r\n  font-size: 1rem;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n}\r\n\r\n.latest-video .video-info h6 {\r\n  margin-top: 10px;\r\n  margin-bottom: 0px;\r\n  font-size: 1rem;\r\n}\r\n\r\n.pop-categories-section {\r\n  margin-top: 50px;\r\n  margin-bottom: 50px;\r\n  padding-left: 52px;\r\n}\r\n\r\n.pop-categories-section .section-heading {\r\n  color: #ffffff;\r\n  margin-bottom: 20px;\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.pop-categories-section .pop-categories .card {\r\n  height: 230px;\r\n  margin-bottom: 20px;\r\n  border: none;\r\n  background: none;\r\n  transition: all 0.2s linear;\r\n  cursor: pointer;\r\n}\r\n\r\n.pop-categories-section .pop-categories .card:hover {\r\n  transform: scale(1.1);\r\n  box-shadow: 1px 1px 10px 2px black;\r\n  z-index: 1;\r\n}\r\n\r\n.pop-categories .card .card-img-overlay {\r\n  color: #ffffff;\r\n  top: unset;\r\n  bottom: 0px;\r\n  padding: 12px;\r\n}\r\n\r\n.pop-categories .card .card-img-overlay h6,\r\n.pop-categories .card .card-img-overlay span {\r\n  margin-bottom: 0px;\r\n  font-size: 14px;\r\n}\r\n\r\n.pop-categories .card .card-img-overlay h3 {\r\n  font-size: 24px;\r\n}\r\n\r\n.pop-categories-section .pop-categories .card > img {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.pop-categories-section .pop-categories {\r\n  margin-bottom: 50px;\r\n}\r\n\r\n.btns {\r\n  display: flex;\r\n  margin: 4px;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.owl-theme .owl-nav.disabled + .owl-dots {\r\n  margin-top: 10px;\r\n  position: absolute !important;\r\n  bottom: 34px;\r\n  left: 134px;\r\n}\r\n\r\n.fa-angle-right {\r\n  color: white;\r\n  padding: 2px 7px;\r\n  font-size: 21px;\r\n  border-radius: 4px;\r\n  background-color: white;\r\n}\r\n\r\n.fa-angle-left {\r\n  color: white;\r\n  padding: 2px 7px;\r\n  font-size: 21px;\r\n  border-radius: 4px;\r\n  background-color: white;\r\n}\r\n\r\n.testTrending img.poster {\r\n  width: 100%;\r\n  height: 48vh !important;\r\n  -o-object-fit: cover;\r\n  object-fit: cover;\r\n}\r\n\r\n\r\n@media (max-width: 700px) {\r\n  .feature-video-section {\r\n    margin-bottom: 50px;\r\n    z-index: 0;\r\n  }\r\n  .dashboard-view-section {\r\n    padding-left: 0px;\r\n  }\r\n  .showcase {\r\n    margin-top: 10px;\r\n    padding-left: 0px;\r\n  }\r\n  .review-view {\r\n    margin-top: 10px;\r\n    padding-left: 0px;\r\n  }\r\n}\r\n\r\n@media (max-width: 991px) {\r\n  .trending-video img.poster {\r\n    height: 300px !important;\r\n  }\r\n  .feature-video-section {\r\n    margin-bottom: 50px;\r\n    z-index: 0;\r\n  }\r\n  .poster {\r\n    width: 100% !important;\r\n    height: 183px !important;\r\n    object-fit: fill;\r\n  }\r\n  .interact-vid-sec {\r\n    padding: 30px 30px 0px !important;\r\n  }\r\n  .custom-height,\r\n  .position-relative.pop5 {\r\n    height: auto !important;\r\n    margin-bottom: 30px;\r\n  }\r\n  .card-body {\r\n    padding-bottom: 20px !important;\r\n  }\r\n  .margin-right-0-mobile {\r\n    margin-right: 0px !important;\r\n  }\r\n  .intro-section,\r\n  .feature-video-section,\r\n  .highly-interactive-section,\r\n  .trending-section,\r\n  .latest-section,\r\n  .pop-categories-section {\r\n    padding-left: 0;\r\n  }\r\n  .intro-section {\r\n    padding-top: 51px;\r\n  }\r\n  .intro {\r\n    margin-bottom: 20px;\r\n  }\r\n  .feature-video .feature-info {\r\n    bottom: 0;\r\n  }\r\n  .feature-video .feature-info {\r\n    position: static !important;\r\n    z-index: 9;\r\n    padding: 15px;\r\n    color: #ffffff;\r\n  }\r\n  .feature-video-section {\r\n    margin-top: 0 !important;\r\n  }\r\n}\r\n\r\n.posterImg {\r\n  padding: 5px;\r\n  width: 100%;\r\n  height: 195px;\r\n  object-fit: contain;\r\n}\r\n\r\n\r\n.hb-film-sec-1 .hb-logo-content {\r\n  display: flex;\r\n}\r\n\r\n.hb-film-sec-1 .hb-logo-content > .logo {\r\n  border-radius: 50%;\r\n  margin-right: 30px;\r\n}\r\n\r\n.hb-film-sec-1 .hb-logo-content > .logo img {\r\n  width: 70px;\r\n  height: 70px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n}\r\n\r\n.hb-logo-content .logo-txt > h3 {\r\n  font-size: 22px;\r\n  display: block;\r\n  word-break: break-all;\r\n}\r\n\r\n.hb-logo-content .logo-txt > p {\r\n  font-size: 14px;\r\n}\r\n\r\n.hb-logo-content .logo-txt > button {\r\n  background-color: #6e5eff;\r\n  padding: 4px 34px;\r\n  font-size: 12px;\r\n  border-radius: 5px;\r\n  outline: none;\r\n  border: none;\r\n  color: white;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.hb-logo-content .logo-txt > h6,\r\n.hb-film-sec-1 .hb-follower-content > h6 {\r\n  font-weight: bold;\r\n  font-size: 15px;\r\n}\r\n\r\n.hb-film-sec-1 .hb-follower-content > p span {\r\n  margin-right: 20px;\r\n  font-size: 15px;\r\n  color: #6e5eff;\r\n}\r\n\r\n.hb-film-sec-1 .hb-follower-content > a {\r\n  border: 1px solid black;\r\n  padding: 4px 12px;\r\n  border-radius: 4px;\r\n  color: black;\r\n  font-size: 12px;\r\n  margin-bottom: 10px;\r\n  display: inline-block !important;\r\n  text-decoration: none;\r\n}\r\n\r\n.slises {\r\n  margin-top: 10px;\r\n  font-size: 14px;\r\n  color: #ffffff;\r\n}\r\n\r\n.test.owl-carousel .owl-nav button.owl-next span {\r\n  color: #fdfdfd !important;\r\n}\r\n\r\n.test.owl-carousel .owl-nav button.owl-prev span {\r\n  color: #ffffff;\r\n}\r\n\r\n.hb-film-sec-1 .hb-follower-content > a {\r\n  margin-right: 10px;\r\n}\r\n\r\n.big-video-card .card-title {\r\n  margin-bottom: 0px;\r\n  font-size: 18px;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n  width: 100;\r\n}\r\n\r\n.big-video-card .card-body {\r\n  padding: 12px 16px;\r\n  background: white;\r\n}\r\n\r\n.big-video-card .card img {\r\n  height: 360px;\r\n  object-fit: cover;\r\n}\r\n\r\n.big-video-card .card-text > span:first-child {\r\n  margin-right: 10px;\r\n}\r\n\r\n.big-video-card .card-text > span:last-child {\r\n  color: #a5a2a2;\r\n  display: block;\r\n  margin-top: 8px;\r\n}\r\n\r\n.big-video-card .card-text > span {\r\n  font-size: 13px;\r\n}\r\n\r\n.history-video-card .hv-card img {\r\n  width: 100%;\r\n  height: 102px;\r\n  object-fit: cover;\r\n}\r\n\r\n.history-video-card > a {\r\n  margin-bottom: 10px;\r\n  text-decoration: none;\r\n  display: block;\r\n  font-size: 14px;\r\n  color: #6e5eff;\r\n}\r\n\r\n.view-all {\r\n  margin-bottom: 10px;\r\n  text-decoration: none;\r\n  display: block;\r\n  font-size: 14px;\r\n  color: #6e5eff;\r\n  position: absolute;\r\n  right: 20px;\r\n  top: -40px;\r\n}\r\n\r\n.big-video-card .over {\r\n  right: 0;\r\n}\r\n\r\n.big-video-card {\r\n  cursor: pointer;\r\n}\r\n\r\n.history-video-card > a:hover .hv-card-text > h5 {\r\n  color: #6e5eff;\r\n}\r\n\r\n.history-video-card > a .row .pl {\r\n  padding-left: 6px;\r\n}\r\n\r\n.history-video-card > h4 {\r\n  font-size: 17px;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.history-video-card .hv-card-text > h5 {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  margin-bottom: 0px;\r\n  color: black;\r\n  transition: all 0.2s linear;\r\n}\r\n\r\n.history-video-card .hv-card-text > span {\r\n  font-size: 13px;\r\n  color: black;\r\n  margin-right: 6px;\r\n  margin-bottom: 8px;\r\n  display: inline-block;\r\n}\r\n\r\n.history-video-card .hv-card-text > p {\r\n  font-size: 12px;\r\n  color: #929090;\r\n}\r\n\r\n.hb-film-sec-2 {\r\n  margin-top: 25px;\r\n}\r\n\r\n.hb-film-sec-3 {\r\n  margin-top: 30px;\r\n}\r\n\r\n.hb-film-sec-3 .recent-con .media-body > h5 {\r\n  font-size: 15px;\r\n  color: #6e5eff;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.hb-film-sec-3 .recent-con .media-body > span {\r\n  display: block;\r\n  font-size: 12px;\r\n}\r\n\r\n.hb-film-sec-3 .rfTab .nav-link.active {\r\n  background-color: unset;\r\n  color: black;\r\n  border-top: 2px solid black;\r\n}\r\n\r\n.hb-film-sec-3 .rfTab .nav-link {\r\n  color: #929090;\r\n  border-radius: unset;\r\n  padding: 6px 0px;\r\n  border-top: 2px solid transparent;\r\n}\r\n\r\n.hb-film-sec-3 ul.rfTab {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.hb-film-sec-4 {\r\n  margin-top: 2px;\r\n  padding-bottom: 20px;\r\n}\r\n\r\n.profile-view {\r\n  margin-top: 29px;\r\n  color: white;\r\n}\r\n\r\n.name1 {\r\n  margin-bottom: 0;\r\n  font-size: 20px;\r\n}\r\n\r\n.major {\r\n  margin-top: 12px;\r\n  margin-bottom: 6px;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n}\r\n\r\n.type-view {\r\n  border: 1px solid;\r\n  border-radius: 3px;\r\n  font-size: 12px;\r\n  padding: 2px 3px;\r\n  text-align: center;\r\n}\r\n\r\n.followers-view {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin-top: 16px;\r\n  font-size: 13px;\r\n}\r\n\r\n.profile-img {\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.profile-img img {\r\n  width: 44px;\r\n  height: 44px;\r\n  border: 2px solid white;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n}\r\n\r\n.profile-img-reply img {\r\n  width: 35px;\r\n  height: 35px;\r\n  border: 2px solid white;\r\n  border-radius: 50%;\r\n}\r\n\r\n.type-view p {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.since {\r\n  margin-bottom: 0;\r\n  font-size: 12px;\r\n  opacity: 0.7;\r\n}\r\n\r\n.hb-film-sec-4 > div h4 {\r\n  font-size: 17px;\r\n  color: black;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.v-choice-carousel img {\r\n  height: 200px;\r\n}\r\n\r\n.v-choice-carousel {\r\n  position: relative;\r\n}\r\n\r\n.v-choice-carousel > .owl-nav {\r\n  width: 100%;\r\n}\r\n\r\n.v-choice-carousel > .owl-nav > button {\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translateY(-325%);\r\n  font-size: 25px !important;\r\n  background-color: white !important;\r\n  border-radius: 50%;\r\n  outline: none;\r\n}\r\n\r\n.dottype {\r\n  display: inline-block;\r\n  left: 0;\r\n  top: 5px;\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 50%;\r\n  margin-right: 0;\r\n  background: #000;\r\n  vertical-align: middle;\r\n  margin-right: 5px;\r\n  font-weight: 600;\r\n}\r\n\r\n.hv-card-text .recent-cat.cateogyclass {\r\n  display: none !important;\r\n}\r\n\r\n.hv-card-text .recent-cat.cateogyclass.class0 {\r\n  display: inline-block !important;\r\n}\r\n\r\n.upli {\r\n  padding-right: 10px;\r\n  font-size: 12px;\r\n  padding-left: 10px;\r\n  word-break: break-all;\r\n  position: relative;\r\n  display: block;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.upli.upli0 {\r\n  font-weight: bold;\r\n}\r\n\r\n.dottype.dottype0 {\r\n  background: #a649c7;\r\n}\r\n\r\n.dottype.dottype1 {\r\n  background: #efb43a;\r\n}\r\n\r\n.dottype.dottype2 {\r\n  background: #3dc99c;\r\n}\r\n\r\n.dottype.dottype3 {\r\n  background: #db6a8e;\r\n}\r\n\r\n.tbalesa {\r\n  width: 100%;\r\n  display: table;\r\n}\r\n\r\n.v-choice-carousel .owl-nav button.owl-next,\r\n.v-choice-carousel .owl-nav button.owl-prev {\r\n  padding: 0px 8px !important;\r\n  border: 2px solid #ffffff;\r\n  color: white;\r\n}\r\n\r\n.v-choice-carousel > .owl-nav button:first-child {\r\n  left: -15px;\r\n}\r\n\r\n.v-choice-carousel > .owl-nav button:last-child {\r\n  right: -15px;\r\n}\r\n\r\n.v-choice-info {\r\n  padding-top: 12px;\r\n}\r\n\r\n.v-choice-carousel .v-choice-info .lr-arrow a {\r\n  position: unset;\r\n  opacity: 1;\r\n  border: 2px solid #727272;\r\n  width: 20px;\r\n  height: 20px;\r\n  border-radius: 2px;\r\n}\r\n\r\n.v-choice-carousel .v-choice-info .lr-arrow {\r\n  float: right;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  width: 45px;\r\n}\r\n\r\n.v-choice-info .carousel-control-prev-icon {\r\n  background-image: url(\"./../../../assets/images/left-arrow.svg\");\r\n  width: 12px;\r\n  height: 12px;\r\n}\r\n\r\n.v-choice-info .carousel-control-next-icon {\r\n  background-image: url(\"./../../../assets/images/right-arrow.svg\");\r\n  width: 12px;\r\n  height: 12px;\r\n}\r\n\r\n.v-choice-info .media img {\r\n  width: 40px;\r\n  height: 40px;\r\n}\r\n\r\n.hb-film-sec-4 .v-choice-info ul {\r\n  padding-left: 0px;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.hb-film-sec-4 .v-choice-info ul li {\r\n  list-style-type: none;\r\n  font-size: 13px;\r\n  color: white;\r\n}\r\n\r\n.tbalesa3 {\r\n  padding: 10px !important;\r\n  z-index: 9;\r\n  margin-left: 65px;\r\n}\r\n\r\n.v-choice-info > span {\r\n  color: #929090;\r\n  font-size: 14px;\r\n}\r\n\r\n.v-choice-info .media .media-body > h6 {\r\n  margin-bottom: 0px;\r\n  font-size: 15px;\r\n}\r\n\r\n.v-choice-carousel .carousel-indicators .active {\r\n  background-color: #6e5eff;\r\n}\r\n\r\n.v-choice-carousel .carousel-caption {\r\n  text-align: left;\r\n  left: 0px;\r\n  top: 0px;\r\n  padding-top: 10px;\r\n  padding-left: 13px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n\r\n.v-choice-carousel .v-choice-info ul li samp {\r\n  margin-right: 2px;\r\n  margin-left: 3px;\r\n}\r\n\r\n\r\n.hb-bullet-c1 {\r\n  color: #6e5eff;\r\n}\r\n\r\n.hb-bullet-c2 {\r\n  color: #dfbd5b;\r\n}\r\n\r\n.hb-bullet-c3 {\r\n  color: #65cf9c;\r\n}\r\n\r\n.hb-bullet-c4 {\r\n  color: #d14870;\r\n}\r\n\r\n\r\n.hb-film-sec-5 .rfTab .nav-link.active {\r\n  background-color: unset;\r\n  color: #6e5eff;\r\n  border-top: 2px solid #6e5eff;\r\n  font-weight: 600;\r\n}\r\n\r\n.hb-film-sec-5 .rfTab .nav-link {\r\n  color: #929090;\r\n  border-radius: unset;\r\n  padding: 6px 20px;\r\n  border-top: 2px solid transparent;\r\n}\r\n\r\n.hb-film-sec-5 .rfTab .nav-link.active .like,\r\n.hb-film-sec-5 .rfTab .nav-link.active .share {\r\n  fill: #6e5eff;\r\n}\r\n\r\n.card .over {\r\n  right: 0;\r\n}\r\n\r\n.like-share-content .card-body > h5 {\r\n  font-size: 16px;\r\n  margin-bottom: 5px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.like-share-content .card-body {\r\n  padding: 12px 10px;\r\n}\r\n\r\n.like-share-content .card-body > p {\r\n  font-size: 12px;\r\n}\r\n\r\n.like-share-content .card-body > p span:last-child {\r\n  color: #a5a2a2;\r\n  display: block;\r\n}\r\n\r\n.like-share-content .card {\r\n  background-color: transparent;\r\n  border: none;\r\n  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);\r\n  margin: 5px;\r\n}\r\n\r\n.like-share-content .row > div {\r\n  padding: 0;\r\n  cursor: pointer;\r\n}\r\n\r\n#hbAct {\r\n  background: #fff;\r\n  padding: 15px 45px;\r\n}\r\n\r\n.activityes img {\r\n  height: 150px;\r\n  object-fit: cover;\r\n}\r\n\r\n.poster {\r\n  width: 93%;\r\n}\r\n\r\n.my-tags {\r\n  margin-top: 10px;\r\n  display: block;\r\n  color: #a5a2a2 !important;\r\n}\r\n\r\n.my-tags span {\r\n  margin-right: 5px;\r\n}\r\n\r\n.like-share-content .card:hover {\r\n  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.5);\r\n  background: #fff;\r\n}\r\n\r\n.afterlogindashboard {\r\n  margin-top: 65px;\r\n  padding-left: 80px;\r\n}\r\n\r\n.hb-follower-content a {\r\n  text-decoration: none;\r\n}\r\n\r\n.recent-cat {\r\n  color: #a5a2a2;\r\n  display: inline-block !important;\r\n  font-size: 13px;\r\n  margin-right: 10px;\r\n}\r\n\r\n.video-container {\r\n  padding-top: 15px;\r\n  padding-bottom: 15px;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.over {\r\n  position: absolute;\r\n  right: 15px;\r\n  top: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  border-radius: 4px;\r\n}\r\n\r\n.over span {\r\n  margin: 5px;\r\n  color: #fff !important;\r\n  font-size: 12px !important;\r\n}\r\n\r\n.over span img {\r\n  width: auto !important;\r\n  height: 14px !important;\r\n}\r\n\r\n.choice p.main-title {\r\n  color: #fff;\r\n  position: absolute;\r\n  top: 10px;\r\n  left: -1px;\r\n  z-index: 9;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  background: #0000007d;\r\n  padding: 3px;\r\n  border-radius: 0px 0px 3px 0px;\r\n}\r\n\r\n.choice .cat {\r\n  margin-right: 10px;\r\n  font-size: 14px;\r\n  padding: 4px;\r\n  position: relative;\r\n  padding-left: 10px;\r\n  display: inline-block;\r\n}\r\n\r\n.choice .cat::before {\r\n  position: absolute;\r\n  top: 11px;\r\n  left: 0;\r\n  content: \"\";\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 50%;\r\n  background: #000;\r\n}\r\n\r\n.choice .stats {\r\n  color: #000;\r\n  margin-right: 10px;\r\n  margin-bottom: 5px;\r\n  display: inline-block;\r\n  font-size: 14px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.img-poster {\r\n  width: 100%;\r\n  margin-top: 10px;\r\n}\r\n\r\n.bullet::before {\r\n  position: absolute;\r\n  top: 11px;\r\n  left: 0;\r\n  content: \"\";\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 50%;\r\n  background: #000;\r\n}\r\n\r\n.active-since {\r\n  margin-bottom: 10px;\r\n  color: #929090;\r\n  font-size: 14px;\r\n}\r\n\r\n@media (max-width: 991px) {\r\n  .afterlogindashboard {\r\n    padding-left: 15px;\r\n  }\r\n  .hb-film-sec-1 .hb-follower-content > a {\r\n    margin-bottom: 10px;\r\n  }\r\n  .history-video-card > a .row .pl {\r\n    padding-left: 15px;\r\n    margin-top: 10px;\r\n    margin-bottom: 30px;\r\n  }\r\n  .activityes img {\r\n    width: 100%;\r\n    height: auto;\r\n    margin-bottom: 10px;\r\n  }\r\n  .history-video-card .hv-card img {\r\n    height: auto;\r\n  }\r\n  .tbalesa3 {\r\n    margin-left: 0;\r\n  }\r\n  .big-video-card .card img {\r\n    height: auto;\r\n  }\r\n}\r\n\r\n::ng-deep .carousel-control-next {\r\n  width: 2% !important;\r\n  position: absolute;\r\n  right: 18px;\r\n}\r\n\r\n::ng-deep .carousel-indicators {\r\n  display: none;\r\n}\r\n\r\n::ng-deep .carousel-control-prev {\r\n  width: 2% !important;\r\n  position: absolute;\r\n  left: 13px;\r\n}\r\n\r\n.interests-type ul {\r\n  list-style: none;\r\n  padding-left: 0px;\r\n  position: relative;\r\n  right: 3px;\r\n}\r\n\r\n.interests-type ul li {\r\n  margin: 0px 4px;\r\n  font-size: 11px;\r\n  border: 1px solid white;\r\n  border-radius: 2px;\r\n  padding: 1px 6px;\r\n  display: inline-block;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n@media only screen and (max-width: 991px) {\r\n  .dashboard-view-section {\r\n    margin-top: 92px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
